import { render, staticRenderFns } from "./OPPendingDetail.vue?vue&type=template&id=a867a424&"
import script from "./OPPendingDetail.vue?vue&type=script&lang=js&"
export * from "./OPPendingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports